import { c as _c } from "react/compiler-runtime";
import { Button, IconButton } from '@repo/design-system/components/ds/button';
import { Icon } from '@repo/design-system/components/ds/icon';
import { Tooltip } from '@repo/design-system/components/ds/tooltip/tooltip';
import { FlexColumn } from '@repo/design-system/components/layout/flex-column';
import { FlexRow } from '@repo/design-system/components/layout/flex-row';
import { ScrollArea } from '@repo/design-system/components/layout/scroll-area';
import { Select, SelectItem } from '@repo/design-system/components/ui/select';
import { TextInput } from '@repo/design-system/components/ui/text-input';
import { Type } from '@repo/design-system/components/ui/type';
import { css } from '@repo/panda/css';
import { useCallback, useMemo, useState } from 'react';
import { composerExternalStyles, composerStyles, dragHandleStyles, emptyStateStyles, orderedPinActionsStyles, orderedPinEditorStyles, orderedPinRowStyles, orderedPinSubtitleStyles, orderedPinTextContainerStyles, orderedPinTitleStyles, pinIdChipStyles, pinListContentStyles, pinListStyles, pinListWrapStyles, pinMetaSepStyles, pinMetaStyles, pinMetaTextStyles, pinStyles, pinThumbFallbackStyles, pinThumbImageClass, pinThumbStyles, selectPinOptionStyles } from './styles';
import type { HeroActionEditorPinDetails, HeroActionEditorPinOption } from './types';
import { formatPinIds, parsePinExternalIds, reorder } from './utils';
export const OrderedPinEditor = t0 => {
  const $ = _c(76);
  const {
    title,
    value,
    onChange,
    getPinDetails,
    currentMapPinOptions,
    excludedCurrentMapPinIds
  } = t0;
  let t1;
  if ($[0] !== value) {
    t1 = parsePinExternalIds(value);
    $[0] = value;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const pinIds = t1;
  const [newPinIds, setNewPinIds] = useState("");
  const [draggedIndex, setDraggedIndex] = useState(null);
  const [dragOverIndex, setDragOverIndex] = useState(null);
  let t2;
  if ($[2] !== onChange) {
    t2 = ids => onChange(formatPinIds(ids));
    $[2] = onChange;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const setPinIds = t2;
  let t3;
  if ($[4] !== newPinIds || $[5] !== pinIds || $[6] !== setPinIds) {
    t3 = () => {
      const idsToAdd = parsePinExternalIds(newPinIds);
      if (idsToAdd.length === 0) {
        return;
      }
      setPinIds([...pinIds, ...idsToAdd.filter(id => !pinIds.includes(id))]);
      setNewPinIds("");
    };
    $[4] = newPinIds;
    $[5] = pinIds;
    $[6] = setPinIds;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  const handleAdd = t3;
  let t4;
  if ($[8] !== currentMapPinOptions) {
    t4 = currentMapPinOptions ?? [];
    $[8] = currentMapPinOptions;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== excludedCurrentMapPinIds || $[11] !== t4) {
    let t6;
    if ($[13] !== excludedCurrentMapPinIds) {
      t6 = pin => !excludedCurrentMapPinIds?.has(pin.externalId);
      $[13] = excludedCurrentMapPinIds;
      $[14] = t6;
    } else {
      t6 = $[14];
    }
    t5 = t4.filter(t6);
    $[10] = excludedCurrentMapPinIds;
    $[11] = t4;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  const availableCurrentMapPins = t5;
  let t6;
  if ($[15] !== pinIds || $[16] !== setPinIds) {
    t6 = pinId => {
      if (!pinId || pinIds.includes(pinId)) {
        return;
      }
      setPinIds([...pinIds, pinId]);
    };
    $[15] = pinIds;
    $[16] = setPinIds;
    $[17] = t6;
  } else {
    t6 = $[17];
  }
  const handleAddCurrentMapPin = t6;
  let t7;
  if ($[18] !== pinIds || $[19] !== setPinIds) {
    t7 = (fromIndex, toIndex) => {
      if (fromIndex === toIndex || fromIndex < 0 || toIndex < 0 || fromIndex >= pinIds.length) {
        return;
      }
      setPinIds(reorder(pinIds, fromIndex, Math.min(toIndex, pinIds.length - 1)));
    };
    $[18] = pinIds;
    $[19] = setPinIds;
    $[20] = t7;
  } else {
    t7 = $[20];
  }
  const handleMove = t7;
  let t8;
  if ($[21] !== pinIds || $[22] !== setPinIds) {
    t8 = pinId_0 => {
      setPinIds(pinIds.filter(id_0 => id_0 !== pinId_0));
    };
    $[21] = pinIds;
    $[22] = setPinIds;
    $[23] = t8;
  } else {
    t8 = $[23];
  }
  const handleRemove = t8;
  const t9 = availableCurrentMapPins.length === 0;
  let t10;
  if ($[24] !== title) {
    t10 = title.toLowerCase();
    $[24] = title;
    $[25] = t10;
  } else {
    t10 = $[25];
  }
  const t11 = `Add current map ${t10}`;
  let t12;
  if ($[26] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <Icon icon="add_location_alt" decorative={true} />;
    $[26] = t12;
  } else {
    t12 = $[26];
  }
  const t13 = availableCurrentMapPins.length > 0 ? "Add Current Map Pin" : "No Current Map Pins Available";
  let t14;
  if ($[27] !== t13) {
    t14 = <Button color="secondary" size="sm" fullWidth={true}>{t12}{t13}</Button>;
    $[27] = t13;
    $[28] = t14;
  } else {
    t14 = $[28];
  }
  let t15;
  if ($[29] !== availableCurrentMapPins) {
    t15 = availableCurrentMapPins.map(_temp);
    $[29] = availableCurrentMapPins;
    $[30] = t15;
  } else {
    t15 = $[30];
  }
  let t16;
  if ($[31] !== handleAddCurrentMapPin || $[32] !== t11 || $[33] !== t14 || $[34] !== t15 || $[35] !== t9) {
    t16 = <Select size="sm" fullWidth={true} searchable={true} portalled={false} virtualized={true} maxHeight={320} itemHeight={52} searchPlaceholder="Search current map pins" onValueChange={handleAddCurrentMapPin} disabled={t9} aria-label={t11} trigger={t14}>{t15}</Select>;
    $[31] = handleAddCurrentMapPin;
    $[32] = t11;
    $[33] = t14;
    $[34] = t15;
    $[35] = t9;
    $[36] = t16;
  } else {
    t16 = $[36];
  }
  let t17;
  if ($[37] === Symbol.for("react.memo_cache_sentinel")) {
    t17 = e => setNewPinIds(e.target.value);
    $[37] = t17;
  } else {
    t17 = $[37];
  }
  let t18;
  if ($[38] !== handleAdd) {
    t18 = e_0 => {
      if (e_0.key === "Enter") {
        e_0.preventDefault();
        handleAdd();
      }
    };
    $[38] = handleAdd;
    $[39] = t18;
  } else {
    t18 = $[39];
  }
  let t19;
  if ($[40] !== newPinIds || $[41] !== t18) {
    t19 = <TextInput value={newPinIds} onChange={t17} onKeyDown={t18} placeholder={"Add pin by external id\u2026"} variant="dark" size="sm" fullWidth={true} />;
    $[40] = newPinIds;
    $[41] = t18;
    $[42] = t19;
  } else {
    t19 = $[42];
  }
  let t20;
  if ($[43] !== title) {
    t20 = title.toLowerCase();
    $[43] = title;
    $[44] = t20;
  } else {
    t20 = $[44];
  }
  const t21 = `Add ${t20}`;
  let t22;
  if ($[45] !== newPinIds) {
    t22 = parsePinExternalIds(newPinIds);
    $[45] = newPinIds;
    $[46] = t22;
  } else {
    t22 = $[46];
  }
  const t23 = t22.length === 0;
  let t24;
  if ($[47] !== title) {
    t24 = title.toLowerCase();
    $[47] = title;
    $[48] = t24;
  } else {
    t24 = $[48];
  }
  const t25 = `Add ${t24}`;
  let t26;
  if ($[49] !== newPinIds) {
    t26 = parsePinExternalIds(newPinIds);
    $[49] = newPinIds;
    $[50] = t26;
  } else {
    t26 = $[50];
  }
  const t27 = t26.length === 0;
  let t28;
  if ($[51] === Symbol.for("react.memo_cache_sentinel")) {
    t28 = <Icon icon="add" decorative={true} />;
    $[51] = t28;
  } else {
    t28 = $[51];
  }
  let t29;
  if ($[52] !== handleAdd || $[53] !== t25 || $[54] !== t27) {
    t29 = <IconButton onClick={handleAdd} color="brand" size="sm" aria-label={t25} disabled={t27}>{t28}</IconButton>;
    $[52] = handleAdd;
    $[53] = t25;
    $[54] = t27;
    $[55] = t29;
  } else {
    t29 = $[55];
  }
  let t30;
  if ($[56] !== t21 || $[57] !== t23 || $[58] !== t29) {
    t30 = <Tooltip content={t21} size="sm" disabled={t23}>{t29}</Tooltip>;
    $[56] = t21;
    $[57] = t23;
    $[58] = t29;
    $[59] = t30;
  } else {
    t30 = $[59];
  }
  let t31;
  if ($[60] !== t19 || $[61] !== t30) {
    t31 = <FlexRow gap="6" className={composerExternalStyles}>{t19}{t30}</FlexRow>;
    $[60] = t19;
    $[61] = t30;
    $[62] = t31;
  } else {
    t31 = $[62];
  }
  let t32;
  if ($[63] !== t16 || $[64] !== t31) {
    t32 = <div className={composerStyles}>{t16}{t31}</div>;
    $[63] = t16;
    $[64] = t31;
    $[65] = t32;
  } else {
    t32 = $[65];
  }
  let t33;
  if ($[66] !== dragOverIndex || $[67] !== draggedIndex || $[68] !== getPinDetails || $[69] !== handleMove || $[70] !== handleRemove || $[71] !== pinIds) {
    t33 = <ScrollArea className={pinListWrapStyles} contentClassName={pinListContentStyles} variant="minimal">{pinIds.length === 0 ? <FlexColumn gap="4" align="center" className={emptyStateStyles}><Icon icon="explore_off" size="xl" decorative={true} className={css({
          color: "whiteAlpha.40"
        })} /><Type variant="body-s" color="white">No pins yet</Type><Type variant="body-xs" className={pinStyles}>Add the current map pin or paste an external ID</Type></FlexColumn> : <ul className={pinListStyles}>{pinIds.map((pinId_1, index) => {
          const details = getPinDetails?.(pinId_1);
          const rowTitle = details?.title ?? pinId_1;
          const initials = getPinInitials(rowTitle);
          return <li key={pinId_1} draggable={true} data-dragging={draggedIndex === index ? "true" : undefined} onDragStart={event => {
            setDraggedIndex(index);
            event.dataTransfer.effectAllowed = "move";
            event.dataTransfer.setData("text/plain", pinId_1);
          }} onDragEnter={() => setDragOverIndex(index)} onDragOver={event_0 => {
            event_0.preventDefault();
            event_0.dataTransfer.dropEffect = "move";
            setDragOverIndex(index);
          }} onDragEnd={() => {
            setDraggedIndex(null);
            setDragOverIndex(null);
          }} onDrop={event_1 => {
            event_1.preventDefault();
            if (draggedIndex !== null) {
              handleMove(draggedIndex, index);
            }
            setDraggedIndex(null);
            setDragOverIndex(null);
          }} className={orderedPinRowStyles({
            isDragging: draggedIndex === index,
            isDropTarget: dragOverIndex === index && draggedIndex !== index
          })}><Tooltip content="Drag to reorder" size="sm"><div className={dragHandleStyles}><Icon icon="drag_indicator" size="sm" decorative={true} /></div></Tooltip><div className={pinThumbStyles}>{details?.imageUrl ? <img src={details.imageUrl} alt="" loading="lazy" className={pinThumbImageClass} /> : <span className={pinThumbFallbackStyles}>{initials}</span>}</div><div className={orderedPinTextContainerStyles}><Type variant="body-s" truncate={true} className={orderedPinTitleStyles} title={rowTitle}>{rowTitle}</Type><div className={pinMetaStyles}><span className={pinIdChipStyles}>{pinId_1}</span>{details?.subtitle ? <><span className={pinMetaSepStyles}>·</span><span className={pinMetaTextStyles} title={details.subtitle}>{details.subtitle}</span></> : !details && <><span className={pinMetaSepStyles}>·</span><span className={pinMetaTextStyles}>Unknown pin</span></>}</div></div><div data-pin-actions="true" className={orderedPinActionsStyles}><Tooltip content="Remove pin" size="sm"><IconButton variant="ghost" onClick={() => handleRemove(pinId_1)} color="secondary" size="sm" aria-label="Remove pin"><Icon icon="close" decorative={true} /></IconButton></Tooltip></div></li>;
        })}</ul>}</ScrollArea>;
    $[66] = dragOverIndex;
    $[67] = draggedIndex;
    $[68] = getPinDetails;
    $[69] = handleMove;
    $[70] = handleRemove;
    $[71] = pinIds;
    $[72] = t33;
  } else {
    t33 = $[72];
  }
  let t34;
  if ($[73] !== t32 || $[74] !== t33) {
    t34 = <FlexColumn gap="12" className={orderedPinEditorStyles}>{t32}{t33}</FlexColumn>;
    $[73] = t32;
    $[74] = t33;
    $[75] = t34;
  } else {
    t34 = $[75];
  }
  return t34;
};
function getPinInitials(value: string): string {
  const letters = value.split(/\s+/).map(part => part.charAt(0)).filter(char => /[a-z0-9]/i.test(char)).slice(0, 2).join('');
  return (letters || value.slice(0, 2)).toUpperCase();
}
function _temp(pin_0) {
  return <SelectItem key={pin_0.externalId} item={{
    label: pin_0.title,
    value: pin_0.externalId
  }} searchText={[pin_0.externalId, pin_0.subtitle].filter(Boolean).join(" ")}><FlexColumn gap="none" className={selectPinOptionStyles}><Type variant="body-xs" truncate={true} className={orderedPinTitleStyles} title={pin_0.title}>{pin_0.title}</Type><Type variant="body-xs" truncate={true} className={orderedPinSubtitleStyles} title={[pin_0.externalId, pin_0.subtitle].filter(Boolean).join(" \xB7 ")}>{[pin_0.externalId, pin_0.subtitle].filter(Boolean).join(" \xB7 ")}</Type></FlexColumn></SelectItem>;
}